import React from 'react';
import { useI18n } from '../i18n/I18nProvider';

// Decorative dashboard preview on the dark half of the login/register card.
// Mirrors the landing hero mockup (PIN-284) so the auth screen shows the
// product instead of an empty panel. Purely presentational — aria-hidden.
const AuthIllustration = () => {
  const { t } = useI18n();

  return (
    <div className="uh-login-dash" aria-hidden="true">
      <div className="uh-login-dash-head">
        <span className="uh-login-dash-title">{t('auth.dashMySites')}</span>
        <span className="uh-login-dash-badge">
          <span className="uh-login-dash-dot uh-login-dash-dot-ok" />
          {t('auth.dashMonitored')}
        </span>
      </div>

      <div className="uh-login-dash-rows">
        <div className="uh-login-dash-row">
          <span className="uh-login-dash-dot uh-login-dash-dot-ok" />
          <span className="uh-login-dash-name">mysite.ru</span>
          <span className="uh-login-dash-uptime">99.98%</span>
          <span className="uh-login-dash-ms">142 ms</span>
        </div>
        <div className="uh-login-dash-row">
          <span className="uh-login-dash-dot uh-login-dash-dot-ok" />
          <span className="uh-login-dash-name">shop.mysite.ru</span>
          <span className="uh-login-dash-uptime">99.95%</span>
          <span className="uh-login-dash-ms">210 ms</span>
        </div>
        <div className="uh-login-dash-row uh-login-dash-row-down">
          <span className="uh-login-dash-dot uh-login-dash-dot-danger" />
          <span className="uh-login-dash-name">api.mysite.ru</span>
          <span className="uh-login-dash-down">{t('auth.dashDown')}</span>
          <span className="uh-login-dash-ms uh-login-dash-ms-danger">503</span>
        </div>
      </div>

      <div className="uh-login-dash-foot">
        <span className="uh-login-dash-foot-label">{t('auth.dashUptime30d')}</span>
        <svg className="uh-login-dash-spark" width="160" height="40" viewBox="0 0 160 40" fill="none">
          <path
            d="M0 28 L16 24 L32 26 L48 16 L64 19 L80 11 L96 14 L112 22 L128 9 L144 12 L160 7 V40 H0 Z"
            fill="rgba(37, 99, 235, 0.12)"
          />
          <path
            d="M0 28 L16 24 L32 26 L48 16 L64 19 L80 11 L96 14 L112 22 L128 9 L144 12 L160 7"
            stroke="#2563eb" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" fill="none"
          />
        </svg>
        <span className="uh-login-dash-uptime">99.97%</span>
      </div>
    </div>
  );
};

export default AuthIllustration;
